import { render } from "./Bottom.vue?vue&type=template&id=50395424&ts=true"
import script from "./Bottom.vue?vue&type=script&lang=ts"
export * from "./Bottom.vue?vue&type=script&lang=ts"

import "./Bottom.vue?vue&type=style&index=0&id=50395424&lang=scss"

import exportComponent from "E:\\vueapp\\xm-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__